export class ProcoreDeleteDirectCostFilters {
  public date?: Date;
}
